// extracted by mini-css-extract-plugin
module.exports = {"search":"MultiselectSearch_search_18fD7","input":"MultiselectSearch_input_fKzME","magnifier":"MultiselectSearch_magnifier_lYLwN"};